import React, { useState, useEffect } from "react";
import styled from "styled-components";
import CommonModal from "../based/Modal";
import TFUSelect from "../based/inputs/TFUSelect";
import WarehouseServices from "../based/services/WarehouseServices";
import { Notify } from "../based/Notify";
import { INITPAGING, NOTIFY } from "../based/Constants";
import PartnerServices from "../based/services/PartnerServices";
import TableFooter from "../based/content/TableFooter";

function WareRackEditModal({ show, onClose }) {
    const [data, setData] = useState([]);
    const [partnerOptions, setPartnerOptions] = useState([]);
    const [paging, setPaging] = useState(INITPAGING);

    console.log("partnerOptions", partnerOptions);

    useEffect(() => {
        if (show) {
            fetchPartnerList({ ...INITPAGING, pageSize: 100 });
            fetchRack(paging);
        }
    }, [show]);

    const saveRackSlot = async (model) => {
        const [err, data] = await WarehouseServices.SaveRackSlotBin(model);
        if (!err && data) {
            Notify(NOTIFY.SUCCESS, NOTIFY.SUCCESS, "Cập nhật thành công");
            fetchRack(paging);
        } else {
            Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Cập nhật thất bại");
        }
    };

    const fetchPartnerList = async (page) => {
        const [err, data] = await PartnerServices.GetPartnerUserModel(page);
        if (!err && data && data.listObjects) {
            const options = data.listObjects.map((item) => ({
                value: item.id,
                label: item.fullName,
            }));
            setPartnerOptions(options);
        } else {
            setPartnerOptions([]);
        }
    };

    const fetchRack = async (page) => {
        const [err, data] = await WarehouseServices.GetWareRackModels(page);
        if (!err && data) {
            setData(data.listObjects);
            setPaging(data.paging);
        } else {
            setPaging(page);
        }
    };

    const deleteRack = async (rackId) => {
        const [err, data] = await WarehouseServices.DeleteRack(rackId);
        if (!err && data) {
            Notify(NOTIFY.SUCCESS, NOTIFY.SUCCESS, "Xóa thành công");
            fetchRack(paging);
        } else {
            Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Xóa thất bại");
        }
    };

    return (
        <CommonModal show={show} onClose={onClose} title="Tùy chinh Rack - Slot - Bin" size="lg" className="ware-rack-edit-modal">
            <Wrapper>
                <section className="table">
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th>Rack</th>
                                <th>Slot</th>
                                <th>Bin</th>
                                <th>Partner áp dụng</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {data && data.length > 0 ? (
                                data.map((item, index) => {
                                    const isEditing = item.isEditing;
                                    return (
                                        <tr key={index}>
                                            <td className="vertical-align-middle">
                                                <div className="rack">
                                                    {isEditing ? (
                                                        <input
                                                            type="text"
                                                            value={item.rackName}
                                                            onChange={(e) => {
                                                                let dt = [...data];
                                                                dt[index].rackName = e.target.value;
                                                                setData(dt);
                                                            }}
                                                            placeholder="Nhập tên khu"
                                                        />
                                                    ) : (
                                                        <span>{item.rackName}</span>
                                                    )}
                                                </div>
                                            </td>
                                            <td className="vertical-align-middle">
                                                <div className="slot">
                                                    {isEditing && item.id == 0 ? (
                                                        <input
                                                            type="number"
                                                            value={item.slotQuantity}
                                                            onChange={(e) => {
                                                                let dt = [...data];
                                                                dt[index].slotQuantity = e.target.value;
                                                                setData(dt);
                                                            }}
                                                            placeholder="Nhập số lượng slot"
                                                        />
                                                    ) : (
                                                        <span>{item.slotQuantity}</span>
                                                    )}
                                                </div>
                                            </td>
                                            <td className="vertical-align-middle">
                                                <div className="bin">
                                                    {isEditing && item.id == 0 ? (
                                                        <input
                                                            type="number"
                                                            value={item.binQuantity}
                                                            onChange={(e) => {
                                                                let dt = [...data];
                                                                dt[index].binQuantity = e.target.value;
                                                                setData(dt);
                                                            }}
                                                            placeholder="Nhập số lượng bin"
                                                        />
                                                    ) : (
                                                        <span>{item.binQuantity}</span>
                                                    )}
                                                </div>
                                            </td>
                                            <td className="list-badge vertical-align-middle">
                                                {isEditing ? (
                                                    <>
                                                        <div className="partner-select">
                                                            <TFUSelect
                                                                placeholder="Thêm đối tác"
                                                                options={partnerOptions}
                                                                onChangedObject={(newVal) => {
                                                                    let dt = [...data];
                                                                    if (!dt[index].partners) dt[index].partners = [];
                                                                    dt[index].partners.push({
                                                                        id: newVal.value,
                                                                        name: newVal.label,
                                                                    });
                                                                    setData(dt);
                                                                }}
                                                            />
                                                        </div>
                                                        <div className="list-select-badge">
                                                            {item.partners &&
                                                                item.partners.length > 0 &&
                                                                item.partners.map((partner, idx) => (
                                                                    <span key={idx} className="badge badge-secondary m-2">
                                                                        {partner.name}
                                                                        <i
                                                                            className="fa fa-times"
                                                                            aria-hidden="true"
                                                                            onClick={() => {
                                                                                let dt = [...data];
                                                                                dt[index].partners.splice(idx, 1);
                                                                                setData(dt);
                                                                            }}
                                                                        ></i>
                                                                    </span>
                                                                ))}
                                                        </div>
                                                    </>
                                                ) : (
                                                    <>
                                                        {item.partners &&
                                                            item.partners.map((partner, idx) => (
                                                                <span key={idx} className="badge badge-secondary m-1">
                                                                    {partner.name}
                                                                </span>
                                                            ))}
                                                    </>
                                                )}
                                            </td>
                                            <td className="vertical-align-middle">
                                                {isEditing ? (
                                                    <button className="btn btn-sm btn-custom m-2" onClick={() => saveRackSlot(item)}>
                                                        Lưu
                                                    </button>
                                                ) : (
                                                    <button
                                                        className="btn btn-sm btn-custom m-2"
                                                        onClick={() => {
                                                            let dt = [...data];
                                                            dt[index].isEditing = true;
                                                            setData(dt);
                                                        }}
                                                    >
                                                        Sửa
                                                    </button>
                                                )}
                                                <button
                                                    className="btn btn-sm btn-danger m-2"
                                                    onClick={(e) => {
                                                        deleteRack(item.id);
                                                    }}
                                                >
                                                    Xóa
                                                </button>
                                            </td>
                                        </tr>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td colSpan="5" className="text-center">
                                        Không có dữ liệu
                                    </td>
                                </tr>
                            )}
                            {/* <tr>
                                <td className="vertical-align-middle">
                                    <div className="rack">
                                        <span>Khu A</span>
                                    </div>
                                </td>
                                <td className="vertical-align-middle">
                                    <div className="slot">
                                        <span>30</span>
                                    </div>
                                </td>
                                <td className="vertical-align-middle">
                                    <div className="bin">
                                        <span>5</span>
                                    </div>
                                </td>
                                <td className="list-badge vertical-align-middle">
                                    <span className="badge badge-secondary m-1">Partner 1</span>
                                    <span className="badge badge-secondary m-1">Partner 2</span>
                                </td>
                                <td className="vertical-align-middle">
                                    <button className="btn btn-sm btn-custom m-2">Sửa</button>
                                    <button className="btn btn-sm btn-danger m-2">Xóa</button>
                                </td>
                            </tr>
                            <tr>
                                <td className="vertical-align-middle">
                                    <div className="rack">
                                        <input type="text" placeholder="Nhập tên khu" />
                                    </div>
                                </td>
                                <td className="vertical-align-middle">
                                    <div className="slot">
                                        <input type="number" placeholder="Nhập số lượng slot" />
                                    </div>
                                </td>
                                <td className="vertical-align-middle">
                                    <div className="bin">
                                        <input type="number" placeholder="Nhập số lượng bin" />
                                    </div>
                                </td>
                                <td className="list-badge vertical-align-middle">
                                    <div className="partner-select">
                                        <TFUSelect placeholder="Thêm đối tác" />
                                    </div>
                                    <div className="list-select-badge">
                                        <span className="badge badge-secondary m-2">
                                            Partner 1<i className="fa fa-times" aria-hidden="true"></i>
                                        </span>
                                    </div>
                                </td>
                                <td className="vertical-align-middle">
                                    <button className="btn btn-sm btn-custom">Lưu</button>
                                    <button className="btn btn-sm btn-danger">Xóa</button>
                                </td>
                            </tr> */}
                        </tbody>
                    </table>
                    <TableFooter
                        paging={paging}
                        onFilter={(newPaging) => {
                            fetchRack(newPaging);
                        }}
                        itemToDisplay={50}
                    />
                    <div className="add-more">
                        <a
                            href=""
                            className="text text-custom"
                            onClick={(e) => {
                                e.preventDefault();
                                let dt = [...data];
                                dt.push({
                                    id: 0,
                                    isEditing: true,
                                    rackName: "",
                                    slotQuantity: 0,
                                    binQuantity: 0,
                                    partners: [],
                                });
                                setData(dt);
                            }}
                        >
                            <span>
                                Thêm khu <i className="fa fa-plus"></i>
                            </span>
                        </a>
                    </div>
                </section>
            </Wrapper>
        </CommonModal>
    );
}

export default WareRackEditModal;

const Wrapper = styled.div`
    .list-badge {
        width: 200px;
    }

    .rack input,
    .slot input,
    .bin input {
        border: none;
        width: 100%;
    }

    .rack {
        width: 150px;
        overflow: hidden;
    }

    .list-select-badge {
        margin: 6px 0;
    }

    span.badge i {
        padding: 4px;
    }

    span.badge {
        vertical-align: middle;
    }
`;
